import { useContext } from 'react';
import qs from 'qs';
import cartCheckoutQuery from './CartCheckoutQuery.gql';
import { CartIdContext } from '../components/Cart/CartIdContext';
import { useApolloClient } from 'react-apollo';
function useLoginRedirect() {
    const { ReturnURL } = __IN_SERVER__
        ? { ReturnURL: null }
        : qs.parse(window.location.search, {
            ignoreQueryPrefix: true
        });
    const { cartId } = useContext(CartIdContext);
    const client = useApolloClient();
    function getRedirectUrl() {
        if (!ReturnURL)
            return;
        if (ReturnURL.startsWith('/checkout')) {
            return client
                .query({
                query: cartCheckoutQuery,
                variables: {
                    cartId
                }
            })
                .then(result => {
                const externalCheckoutUrl = result.data.cart.externalCheckoutUrl;
                return externalCheckoutUrl;
            });
        }
        else {
            return Promise.resolve(ReturnURL);
        }
    }
    return { getRedirectUrl };
}
export { useLoginRedirect };
//# sourceMappingURL=useLoginRedirect.js.map